export default __webpack_public_path__ + "static/media/Saboteur Ring.acddd768.jpg";